/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */

import { NgModule } from '@angular/core';
import { NbBadgeComponent } from './badge.component';

@NgModule({
  exports: [ NbBadgeComponent ],
  declarations: [ NbBadgeComponent ],
})
export class NbBadgeModule { }
